(() => {
  const intro = document.querySelector('[data-aora-intro]');
  if (!intro) return;

  const key = 'nakr-intro-seen-v2';
  const oncePerSession = intro.dataset.oncePerSession === 'true';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  try {
    if (oncePerSession && sessionStorage.getItem(key) === '1') {
      intro.remove();
      return;
    }
  } catch (error) {
    // Storage can be unavailable in some privacy modes; the intro still works.
  }

  const duration = reducedMotion ? 650 : Number(intro.dataset.duration || 1000);
  const root = document.documentElement;
  let finished = false;

  const finish = () => {
    if (finished) return;
    finished = true;
    intro.classList.add('is-leaving');
    root.classList.remove('aora-intro-lock');

    try {
      if (oncePerSession) sessionStorage.setItem(key, '1');
    } catch (error) {}

    window.setTimeout(() => intro.remove(), 720);
  };

  // Mark the visit as seen as soon as the intro starts. This guarantees that
  // returning to the homepage via the header logo will not replay it, even if
  // the visitor navigates away before the animation has fully finished.
  try {
    if (oncePerSession) sessionStorage.setItem(key, '1');
  } catch (error) {}

  root.classList.add('aora-intro-lock');
  window.requestAnimationFrame(() => intro.classList.add('is-playing'));
  window.setTimeout(finish, duration);

  // Visitors can always skip the intro with a click, tap, Escape or Enter.
  intro.addEventListener('click', finish, { once: true });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' || event.key === 'Enter' || event.key === ' ') finish();
  }, { once: true });

  // Hard safety: never leave the storefront locked.
  window.setTimeout(finish, 5000);
})();
